import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component AccessLogIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <AccessLogIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <AccessLogIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const AccessLogIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="AccessLogIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M8.127 13.646a.5.5 0 0 1 .146.354v3H9.37a.5.5 0 0 1 0 1H7.773a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .854-.354" />
      <path
        fillRule="evenodd"
        d="M10.42 13.646a.5.5 0 0 1 .353-.146h2a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .146-.354Zm.853.854V17h1v-2.5z"
        clipRule="evenodd"
      />
      <path d="M14.5 13.5a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5H16a.5.5 0 0 0 0 1v.5h-1v-2.5h1.5a.5.5 0 0 0 0-1z" />
      <path
        fillRule="evenodd"
        d="M5 2h11.03L21 7.075V20a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m10.19 2H5v16h14V7.891z"
        clipRule="evenodd"
      />
    </svg>
  )
);
AccessLogIcon.displayName = "AccessLogIcon";
export default AccessLogIcon;
